var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"18","height":"20","fill":"currentColor","viewBox":"0 0 18 20"}},[_c('path',{attrs:{"d":"M16 0H2C.9 0 .01.9.01 2L0 20l4-4h12c1.1 0 2-.9 2-2V2c0-1.1-.9-2-2-2Zm-6 12H8v-2h2v2Zm0-4H8V4h2v4Z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }